import React from 'react';
import { Link } from 'react-router-dom';
import { FaTrophy, FaHourglassHalf, FaFutbol } from 'react-icons/fa';
import { Winner, SectionCard } from '../components';

const WinnerPage = ({ winner }) => {
  if (!winner) {
    return (
      <SectionCard title="Campeón" icon={<FaTrophy />} description="La gloria del torneo ya tiene dueño.">
        <div className="empty-state">
          <h3><FaHourglassHalf /> Aún no hay campeón</h3>
          <p>Completa la gran final para conocer al ganador del torneo.</p>
          <Link to="/semifinal" className="btn btn--accent empty-state__action">
            <FaFutbol /> Ir a la gran final
          </Link>
        </div>
      </SectionCard>
    );
  }

  return <Winner winner={winner} />;
};

export default WinnerPage;
